import { useEffect } from 'react'
import { TreeNodeOrNodeSlug, useIsChatEnabled } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useNotificationIndicatorSidebarItem } from '@/features/chat/useNotificationIndicatorSidebarItem'
import { useSidebarLayers } from '@/features/layout/hooks/useSidebarLayers'
import { generatePathWithRoot } from '@/features/layout/utils/generatePathWithRoot'
import { useAppSelector } from '@/store/hooks'

export const COURSE_DETAILS_SLUG = 'course-details'
export const COURSE_CONTENT_SLUG = 'course-content'
export const COURSE_CHAT_SLUG = 'course-chat'

type Options = {
  hideContent?: boolean
}

export const useSetCourseSidebarLayers = ({ hideContent }: Options = {}) => {
  const aggregate = useAppSelector((state) => state.aggregate.current)
  const isChatEnabled = useIsChatEnabled()

  const { setLayers } = useSidebarLayers()

  const { t } = useTranslation()

  const notificationIndicator = useNotificationIndicatorSidebarItem()

  useEffect(() => {
    const detailsPath = generatePathWithRoot(`/courses/${aggregate?.objective?.id}/view/details`)
    const contentPath = generatePathWithRoot(`/courses/${aggregate?.objective?.id}/view/content`)

    const layers: TreeNodeOrNodeSlug[] = [
      {
        name: t('resourcesWizard.details'),
        url: detailsPath,
        slug: COURSE_DETAILS_SLUG,
        icon_id: 'InformationInCircleBold',
      },
    ]

    if (!hideContent) {
      layers.push({
        name: t('resourcesWizard.content'),
        url: contentPath,
        slug: COURSE_CONTENT_SLUG,
        icon_id: 'FileBoldStroke',
      })
    }

    if (isChatEnabled) {
      layers.push(notificationIndicator)
    }

    setLayers(layers)
  }, [aggregate?.objective?.id, setLayers, hideContent, t, notificationIndicator, isChatEnabled])
}
